import React, { useContext, useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { studentContext } from '../../StudentProfile';
import Modal from '../../../../../../components/Modal/Modal';
import Form from '../../../../../../components/Form/Form';
import Input from '../../../../../../components/Input/Input';
import { parse } from 'papaparse';
import LoadAndRender from '../../../../../../components/LoadAndRender/LoadAndRender';
import SelectClassSection from '../../../../../../components/SelectClassSection/SelectClassSection';
import { toast } from 'react-toastify';
import { dashboardContext } from '../../../../Dashboard';
import { Access } from '../../../PortalAccess/AccessEnum';

import { useQuery } from '@apollo/client';
import { GET_STUDENT_TAGS } from '../../../SchoolTags/Querries';

import ConfirmationBox from '../../../../../../components/ConfirmationBox/ConfirmationBox';
import { SEND_WHATSAPP_REMINDER_TO_STUDENT } from '../studentDetails/Queries';
import { useMutation } from '@apollo/client';
import Pagination from '../../../../../../components/Pagination/Pagination';
import { GET_STUDENTS } from '../../../FeeCollection/pages/CollectOverview/Queries';
import Table, { RowsPerPageSelect } from '../../../../../../components/Table/Table';

const downloadTxtFile = (array: any[]) => {
	const element = document.createElement('a');
	const file = new Blob([array.map((d, i) => `${i + 1}) ${d}`).join('\n')], { type: 'text/plain;charset=utf-8' });
	element.href = URL.createObjectURL(file);
	element.download = 'Error_Log_File.txt';
	document.body.appendChild(element);
	element.click();
};
function array2json(data: any, sections: any, close: any) {
	var headers = data.data[0];

	var result: any = [];
	var res: any = [];
	const validClasses = sections.map((d: any) => d.class);
	const validSections = sections
		.map((d: any) => d.section)
		.filter((value: any, index: any) => sections.map((d: any) => d.section).indexOf(value) === index);
	let validCategories = ['obc', 'sc', 'st', 'general'];
	let validGender = ['male', 'm', 'female', 'f', 'other', 'o'];
	let errors: string[] = [];
	const seenIds = new Set();
	for (var i = 1; i < data.data.length; i++) {
		var obj: any = {};
		for (var j = 0; j < headers.length; j++) {
			obj[headers[j]] = data.data[i][j];
		}
		result.push(obj);
	}
	for (const student of result) {
		const {
			name,
			category,
			class: studentClass,
			section,
			school_generated_id: schoolId,
			gender,
			has_sibling,
		} = student;
		let hasError = false;
		if (!has_sibling) {
			errors.push(`The 'has_sibling' field does not have any value for student '${name}'.`);
			hasError = true;
		}
		if (!validCategories.includes(category.toLowerCase())) {
			errors.push(
				`Invalid category '${category}' for student '${name}'. Valid categories are ${validCategories.join(', ')}.`,
			);
			hasError = true;
		}
		if (!validGender.includes(gender.toLowerCase())) {
			errors.push(`Invalid gender '${gender}' for student '${name}'. Valid gender are ${validGender.join(', ')}.`);
			hasError = true;
		}

		if (!validClasses.includes(studentClass)) {
			errors.push(
				`Invalid class '${studentClass}' for student '${name}'. Valid classes are ${validClasses.join(', ')}.`,
			);
			hasError = true;
		}
		if (!validSections.includes(section)) {
			errors.push(
				`Invalid section '${section}' for student '${name}'. Valid sections are ${validSections.join(', ')}.`,
			);
		}
		if (seenIds.has(schoolId)) {
			errors.push(`Duplicate school_generated_id '${schoolId}' found for student '${name}'. Each ID must be unique.`);
			hasError = true;
		} else {
			seenIds.add(schoolId);
		}
		if (!hasError) {
			res.push({ ...student, has_sibling: student.has_sibling.toLowerCase(), category: category.toLowerCase() });
		}
	}

	if (errors.length) {
		close(false);
		toast.error(
			({ closeToast }) => (
				<div className='flex flex-col z-50 max-w-fit'>
					<span>Download Error Log File ❗</span>
					<button onClick={() => downloadTxtFile(errors)}>click here</button>
				</div>
			),
			{ autoClose: 10000 },
		);
	} else {
		console.log(res);

		return res;
	}
}
function csv2json(file: any, sections: any, close: any): any {
	return new Promise(async (resolve, reject) => {
		try {
			parse(file, {
				complete: (results) => {
					resolve(array2json(results, sections, close));
				},
				skipEmptyLines: true,
			});
		} catch (error) {
			window.alert("Couldn't parse the file");
		}
	});
}

const create_students_via_csv = async (data: any) => {
	var myHeaders = new Headers();
	myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
	myHeaders.append('Content-Type', 'application/json');

	var raw = JSON.stringify(data);

	var requestOptions: RequestInit = {
		method: 'POST',
		headers: myHeaders,
		body: raw,
		redirect: 'follow',
	};

	const res: any = await fetch(
		process.env.REACT_APP_BACKEND_URL + '/api/student/create-student-via-csv',
		requestOptions,
	);

	if (res.ok) {
		window.location.reload();
		return await res.json();
	} else {
		let message = await res.json();
		if (message.statusCode === 401) {
			localStorage.removeItem('token');
			//window.location.reload();
		}
		toast.error(`${message.message}`, {
			position: 'top-center',
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: 'light',
		});
	}
};

// const get_section_wise_students = async (section_id: string) => {
// 	var myHeaders = new Headers();
// 	myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

// 	var requestOptions: RequestInit = {
// 		method: 'GET',
// 		headers: myHeaders,
// 		redirect: 'follow',
// 	};
// 	console.log(section_id);

// 	const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/school/section/' + section_id, requestOptions);
// 	console.log(res);

// 	if (res.ok) {
// 		return await res.json();
// 	} else {
// 		const message = await res.json();
// 		if (message.statusCode === 401) {
// 			localStorage.removeItem('token');
// 			window.location.reload();
// 		}
// 	}
// };

const get_formated_date = (_dateStr: any) => {
	const dateStr = _dateStr || '25-03-2001';
	let dateParts;
	if (dateStr.includes('-')) {
		dateParts = dateStr.split('-');
	}
	if (dateStr.includes('/')) {
		dateParts = dateStr.split('/');
	}

	return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
};

const StudentList = () => {
	const [studentId, setStudentId] = useState('');

	const [csv_link, set_csv_link] = useState('');
	const [csv_sample_link, set_csv_sample_link] = useState('');
	const [_class, setClass] = useState('');
	const [open, set_open] = useState(false);
	const [csv_student_list, set_csv_student_list] = useState([]);
	const [section_id, set_section_id] = useState('');
	const { user, students: all_students, sections } = useContext(dashboardContext);

	const [send_whatsapp_reminder_to_student] = useMutation(SEND_WHATSAPP_REMINDER_TO_STUDENT);
	const [sendReminderConfirmationModal, setSendReminderConfirmationModal] = useState(false);

	// useEffect(() => {
	// 	if (students?.length > 1) {
	// 		const rows = [
	// 			['name', 'father_name', 'school_generated_id', 'class', 'section', 'gender', 'phone_number', 'category', 'dob'],
	// 			...students?.map((student: any) => {
	// 				return [
	// 					student.name,
	// 					student.father_name,
	// 					student.school_generated_id,
	// 					student.class,
	// 					student.section,
	// 					student.gender,
	// 					student.phone_number,
	// 					student.category,
	// 					new Date(student.dob).toLocaleDateString(),
	// 					student.has_sibling,
	// 				];
	// 			}),
	// 		];

	// 		let csvContent = 'data:text/csv;charset=utf-8,' + rows.map((e) => e.join(',')).join('\n');
	// 		var encodedUri = encodeURI(csvContent);
	// 		var encodedUri_sample = encodeURI(
	// 			'data:text/csv;charset=utf-8,' +
	// 				[
	// 					'name',
	// 					'middle_name',
	// 					'last_name',
	// 					'father_name',
	// 					'school_generated_id',
	// 					'class',
	// 					'section',
	// 					'gender',
	// 					'phone_number',
	// 					'category',
	// 					'dob',
	// 					'email_id',
	// 					'roll_number',
	// 					'date_of_addmission',
	// 					'blood_group',
	// 					'address_line1',
	// 					'address_line2',
	// 					'city',
	// 					'state',
	// 					'pin',
	// 					'country',
	// 					'aadhar_number',
	// 					'pan_number',
	// 					'father_contact_number',
	// 					'father_email_id',
	// 					'father_education_qualification',
	// 					'father_occupation',
	// 					'father_work_organization',
	// 					'father_designation',
	// 					'father_annual_income',
	// 					'mother_name',
	// 					'mother_contact_number',
	// 					'mother_email_id',
	// 					'mother_education_qualification',
	// 					'mother_occupation',
	// 					'mother_work_organization',
	// 					'mother_designation',
	// 					'mother_annual_income',
	// 					'guardian_name',
	// 					'guardian_contact_number',
	// 					'guardian_email_id',
	// 					'guardian_relationship',
	// 					'guardian_education_qualification',
	// 					'guardian_occupation',
	// 					'guardian_work_organization',
	// 					'guardian_designation',
	// 					'guardian_annual_income',
	// 					'religion',
	// 					'nationality',
	// 					'bpl_student',
	// 					'bpl_card_number',
	// 					'person_with_disability',
	// 					'type_of_disability',
	// 					'identification_mark',
	// 					'mother_tougue',
	// 					'second_language',
	// 					'emergency_contact_number',
	// 					'single_parent_child',
	// 					'sponsored_student',
	// 					'sponsored_name',
	// 					'bank_name',
	// 					'bank_account_number',
	// 					'ifsc_code',
	// 					'account_holder_name',
	// 					'weight',
	// 					'height',
	// 					'bmi',
	// 					'allergies',
	// 					'school_name',
	// 					'school_address',
	// 					'board',
	// 					'medium_of_instruction',
	// 					'tc_number',
	// 					'last_class_passed',
	// 					'percentage_of_last_class_passed',
	// 					'has_sibling',
	// 				].join(',') +
	// 				'\n',
	// 		);
	// 		set_csv_link(encodedUri);
	// 		set_csv_sample_link(encodedUri_sample);
	// 	}
	// }, [students]);
	const [student, setStudent] = useState<any>(null);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState({
		name: 10,
	});
	const {
		data: studentData,
		loading: studentLoading,
		error: studentError,
	} = useQuery(GET_STUDENTS, {
		variables: {
			school_id: user?.school?._id,
			trustee_id: user?.school?.trustee_id,
			student_id: null,
			page,
			limit: limit?.name,
		},
	});

	return (
		<div className='mr-5'>
			<div className='w-full  font-semibold '>
				<div className='flex justify-between my-6 items-center'>
					{/* <div className='bg-[#817DFF]  items-center bg-opacity-10 flex py-3  px-6 max-w-md w-full rounded-[24px]'>
						<i className='text-edvion_black text-opacity-50 fa-solid fa-magnifying-glass'></i>
						<input
							onChange={(e) => setInputText(e.target.value)}
							type='text'
							placeholder='Search by student name, enrolment number'
							className='ml-4 bg-transparent focus:outline-none w-full placeholder:font-normal'
						/>
					</div> */}
					{/* <SelectClassSection
						className='flex'
						onChange={(s: any) => {
							setClass(s.class);
							set_section_id(s.section);
						}}
					></SelectClassSection> */}
					{/* <button
						onClick={() => setAddStudent(true)}
						className='m-2 bg-[#6F6AF8] text-white rounded-lg font-medium py-2 px-5'
					>
						Add New Student
					</button> */}
					{/* <div className='flex'>
						{(user?.access === Access.SUPER || user.access === Access.ALL_ACCESS) && (
							<a
								download='students.csv'
								href={csv_link}
								className=' ml-auto m-2 border-2 border-violet-500 rounded-lg text-violet-500 font-medium py-2 px-5'
							>
								Download CSV File
							</a>
						)}

						<button
							className='m-2 bg-[#6F6AF8] text-white rounded-lg font-medium py-2 px-5'
							onClick={() => set_open(true)}
						>
							Upload Student Data
						</button>
					</div> */}
				</div>
			</div>

			<Modal title='Upload CSV File ( Bulk Data )' open={open} setOpen={set_open}>
				<div className='flex w-full'>
					<div className='mx-auto'>
						<Form
							onSubmit={async (data: any) => {
								await create_students_via_csv(csv_student_list);
								set_open(false);
							}}
						>
							<Input
								type='file'
								onChange={async (value: any, e: any) => {
									const student_updated_list = await csv2json(e.target.files[0], sections, set_open);

									set_csv_student_list(
										student_updated_list
											?.filter((row: any) => {
												const res: any = Object.values(row);
												return !/^,+$/g.test(res);
											})
											.map((row: any) => {
												switch (row['gender']) {
													case 'Female':
													case 'F':
													case 'f':
														row['gender'] = 'female';

														break;
													case 'Male':
													case 'M':
													case 'm':
														row['gender'] = 'male';

														break;
													case 'Other':
													case 'O':
													case 'o':
														row['gender'] = 'other';

														break;
												}

												return {
													...row,
													gender: row['gender'],
													category: row['category']?.toLowerCase(),
													dob: get_formated_date(row['dob']),
													date_of_addmission: get_formated_date(row['date_of_addmission']),
												};
											}),
									);
								}}
								label='CSV File'
							/>
							<a
								download='add_students_sample.csv'
								href={csv_sample_link}
								className=' border-none text-sm text-violet-500  font-normal outline-0 mb-0'
							>
								Download CSV Sample File
							</a>

							<button type='submit' className='m-2 mt-6 bg-[#6F6AF8] text-white rounded-lg font-medium py-2 px-5'>
								Upload
							</button>
						</Form>
					</div>
				</div>
			</Modal>
			<Modal open={sendReminderConfirmationModal} setOpen={setSendReminderConfirmationModal}>
				<ConfirmationBox
					setOpen={setSendReminderConfirmationModal}
					funtion={() => {
						send_whatsapp_reminder_to_student({
							variables: {
								student_id: studentId,
							},
						});
					}}
					confirmationText='send reminder'
					ButtonText='Send Reminder'
				/>
			</Modal>
			<LoadAndRender loading={studentLoading}>
				{studentData && (
					<div className='w-full'>
						{/* <h2>this div may need to remove after some fixes</h2> */}
						<div className='grid grid-cols-7'>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
						<Table
							heading={
								<div className='bg-[#817DFF] mt-2 max-w-md h-12 mb-2 ml-2 items-center bg-opacity-10 flex py-3 px-6 rounded-[24px]'>
									<i className='text-edvion_black text-opacity-50 fa-solid fa-magnifying-glass'></i>
									<input
										//onChange={(e) => set_search_input(e.target.value)}
										type='text'
										placeholder='Search by student name, enrolment number'
										className='ml-4 bg-transparent focus:outline-none w-full placeholder:font-normal placeholder:text-base'
									/>
								</div>
							}
							perPage={
								<div className=' flex justify-end items-center  '>
									<RowsPerPageSelect
										setItemsPerRow={(e: any) => {
											setLimit(e);
										}}
										itemsPerRow={limit}
										className=' justify-start'
									/>
								</div>
							}
							data={[
								['Sr.No.', 'Name', 'Email ID', 'Roll No.', 'Total Amount', 'Total Paid', 'Total Due', 'Action'],

								...studentData.getStudents.students_detail
									// .filter((s: any) =>
									// 	[s.name, s.father_name, s.school_generated_id]
									// 		.join(',')
									// 		.toLowerCase()
									// 		.includes(search_input.toLowerCase()),
									// )
									//.sort((a: any, b: any) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
									.map((r: any, index: number) => [
										<span className='w-20'>{(page - 1) * limit.name + index + 1}</span>,
										<Link to={'/student_profile/' + r.student_id} state={{ student: r }}>
											<span className='text-base text-violet-500'>{r?.student_name ? r?.student_name : '-'}</span>
										</Link>,
										r?.student_email,
										r?.school_generated_id ? r?.school_generated_id : 'N/A',
										<h2> {r?.total_amount ? '₹ ' + r?.total_amount?.toLocaleString('hi') : 'N/A'}</h2>,
										<h2 className={'' + (r?.previous_session_dues_paid ? ' text-[#2EB418]' : ' ')}>
											{r?.previous_session_dues_paid
												? '₹ ' + r?.previous_session_dues_paid?.toLocaleString('hi')
												: 'N/A'}
										</h2>,
										<h2 className={' ' + (r?.previous_session_dues ? ' text-[#FC4343]' : '')}>
											{r?.previous_session_dues ? '₹ ' + r?.previous_session_dues?.toLocaleString('hi') : 'N/A'}
										</h2>,
										// <CollectFeeButton school_id={r?.school_id} student_id={r?.student_id} />,
										// <button
										// 	onClick={() => {
										// 		// setShowModal(true);
										// 		setStudent(r);

										// 		// Mixpanel.track('collect_fee_button', {
										// 		// 	user_name: user?.name,
										// 		// 	schoolId: r.school?.id,
										// 		// 	school: r.school?.name,
										// 		// 	studentId: r?._id,
										// 		// 	studentName: r?.name,
										// 		// });
										// 	}}
										// 	className={` py-1.5 text-edvion_black text-base bg-indigo-200 px-4 rounded-[8px] `}
										// >
										// 	Collect Fee
										// </button>,
										<div>
											<i
												onClick={() => {
													setStudent(r);
													//setSendReminderConfirmationModal(true);
												}}
												className='fa-solid fa-ellipsis-vertical cursor-pointer'
												aria-hidden='true'
											></i>
										</div>,
									]),
							]}
							footer={<Pagination page={page} setPage={setPage} totalPageNo={studentData.getStudents?.total_pages} />}
						/>
					</div>
				)}
			</LoadAndRender>
		</div>
	);
};

export default StudentList;
